import { GetSurveyRequestSchema, GetSurveyResponseSchema } from './get-survey.schema';
/**
 * Get Survey Endpoint Contract
 * Retrieves a specific survey by ID
 */ export const getSurveyContract = {
    method: 'GET',
    path: '/api/v2/survey/:id',
    description: 'Retrieve a specific survey by ID',
    requestSchema: GetSurveyRequestSchema,
    responseSchema: GetSurveyResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Survey not found'
        }
    }
};

//# sourceMappingURL=get-survey.contract.js.map